// 这里的lbeToken是动态的，所以不能写死在拦截器

import { query } from '@/utils/const';
import { Message } from '@arco-design/web-react';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { localMemory } from 'localmemory';
import { ENV, identityId } from '@/env';
import { errorMsg } from './serverCode';

export interface IAxiosResp<T> {
  code: number;
  msg: string; // message
  success: boolean;
  data?: T;
  [key: string]: any;
}

const defaultConfig = {
  baseURL: ENV.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
};

const instance = axios.create(defaultConfig);

instance.interceptors.request.use(
  (config) => {
    config.headers.lbeSign = query.sign;
    config.headers.lbeIdentity = identityId;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (resp) => {
    if (resp.data.code !== 0) {
      if (resp.data.code === errorMsg.knowledgePointNotExistError.code) {
        Message.error($t(errorMsg.knowledgePointNotExistError.msg));
      } else if (
        ![
          errorMsg.sessionError.code,
          errorMsg.sessionFail.code,
          errorMsg.sessionTimeout.code,
        ].includes(resp.data.code as any)
      ) {
        resp.data.msg ? Message.error(resp.data.msg) : Message.error('error');
      }
    }
    return {
      ...resp.data,
      success: resp.data.code === 0,
    };
  },
  (err) => {
    if (err.code === 'ERR_NETWORK') {
      return Promise.reject(err);
    }
    const msg = err.response?.data?.msg;
    msg ? Message.error(msg) : Message.error('error');
    return Promise.reject(err);
  }
);

export default instance;

export const $POST = async <T>(
  url: string,
  payload: object = {},
  config?: AxiosRequestConfig<any>,
  initData?: T
): Promise<IAxiosResp<T>> => {
  const resp = await instance.post<T, IAxiosResp<T>>(url, payload, config);
  if (!resp.success && initData) {
    return {
      ...resp,
      data: {
        ...initData,
      },
    };
  }
  return resp;
};

export const $GET = <T>(url: string, payload: object = {}): Promise<IAxiosResp<T>> => {
  return instance.get<T, IAxiosResp<T>>(url, { params: payload });
};

export const $PUT = async <T>(
  url: string,
  payload: object = {},
  config?: AxiosRequestConfig<any>,
  initData?: T
): Promise<IAxiosResp<T>> => {
  const resp = await instance.put<T, IAxiosResp<T>>(url, payload, config);
  if (!resp.success && initData) {
    return {
      ...resp,
      data: {
        ...initData,
      },
    };
  }
  return resp;
};
